/*

Ashraf 11/28/2022 2698947782 disabled category field
Ashraf 11/29/2022  2698947782 fixed repo name uppercase
Gummala Prakash 11/29/2022 2698947782 Fixed Field Responsiveness.
Ashraf 11/30/2022 2698947782 disabled data repo edit
Ashraf 11/30/2022 2698947782 fixed value bug
Ashraf 11/30/2022 2698947782 fixed field value issue
Poornima 12/01/2022 2698947782 fixed table name field space issue
Poornima 12/01/2022 2698947782 fixed table name reset issue
Poornima 12/02/2022 2698947782  added fields reset issue, error message if no field is added
Ashraf 12/03/2022 2698947782 fixed repo description reset
Sai maheshwar 12/04/2022 2698947782 added unsaved changes alert
Poornima 12/07/2022 2698947782 Changed error message and fixed repository name error issue
Poornima 12/07/2022 2698947782 added auto highlight to autocomplete fields
Dilip 12/07/2022 2698947782  added data repository system notes
Poornima 12/08/2022 2701012930 Added download usage and configuration buttons
Saikrishna 12/08/2022 2698947782  Removed system notes and added in actions
Lalitha 12/09/2022  2698947782  Added reusable backButtonText
Rajesh 12/09/2022 2698947782 reset issue and back search enable
Raghu 12/18/2022 2698947782 Fixed Validation message alignment issue
Rohini 12/19/2022 2698947782 commented the buttons code for the replacement in the table
kavyareddy 12/19/2022 2698947782 Repository name AutoSuggestion for exist one
Ashraf 12/21/2022 2698947782 fixed role access delete issue
Ashraf 02/01/2023 2698947782 fixed unsaved popup changes
Sohel 02/13/2023 2698947782 Added Repository name delete validation
Akhila 02/16/2023 2698947782 repository name cursor issue fixed
Ravi 02/20/2023 2698947782 fixed validation issue in repositoryName
Suresh peddavoora 02/21/2023 2698947782 TextFields and table alignments
Guru Prasad 02/27/2023 2698947782 fixed table name fields in data management
Rohini 03/01/2023 2698947782 worked on the code enhancements.
sohel 03/06/2023 2698947782 Added validation message for existing value
Sohel 03/10/2023 2698947782 Fixed Sequenece Number Issue
Sohel 03/14/2023 2698947782 Fixed Table Name Validation Issue
Prakash 03/17/2023 2698947782 fixed alignments issues.
Prakash 03/17/2023 2698947782 fixed alignments in Responsive and desktop.
Ravi 04/19/2023 2698947782 changed bydefault value of Table Name Based on Category
Sohel 05/26/2023 2698947782 Fixed data Repository table name payload issue
Ravi 06/22/2023 2698947782 fixed submit issue
Sohel 09/24/2023 5155351299 Added Base and Extended Repository UI
Sohel 09/26/2023 5155351299 Changed SAVE API payload and Pre-populate Data
Sohel 09/26/2023 5155351299 Company lookup data change and integerated
Sohel 09/27/2023 5155351299 Added Table Name Validation Based on repository Name
Sohel 09/28/2023 5155351299 disabled Criteria Field
Sohel 09/29/2023 5155351299 Added Company Validation
Sohel 09/29/2023  5155351299 Extended Repository Added Field Description
Sohel 09/30/2023 5155351299 disabled Criteria Field in Base Repository
Sohel 09/30/2023 5155351299 Fixed Save Button Disabled Issue.
Sohel 10/01/2023 5155351299 Added All Option in Company.
Sohel 10/01/2023 5155351299 Fixed Company Validation Issue
Sohel 10/02/2023 5155351299 Changed All label
Sohel 10/02/2023 5155351299 Change All option Functionality
Sohel 10/04/2023 5155351299 Added Criteria Field CheckBox
Sohel 10/04/2023 5155351299 Changed Validation Message
Sohel 10/04/2023 5155351299 Fixed Table Name Prefix Issue
Sohel 10/05/2023 5155351299 Added Is Extendable Field
Sohel 10/10/2023 5155351299 Fixed Base Repository Pre populate Issue
Sohel 10/20/2023 5155351299 Changed Table Name Format
Sohel 12/11/2023 5155351299 Changed Repository Name and Repository Description 
*/

import React, {useState, useEffect, useContext, useRef} from 'react';
import {Field, FieldArray, Formik} from 'formik';
import * as Yup from 'yup';
import {
  Button,
  Checkbox,
  FormHelperText,
  InputAdornment,
  MenuItem,
  TextField,
} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import {
  postDataRepository,
  fetchExistingDataRepositoryNames,
  resetDataRepo,
  resetDownloadMessage,
  getDropDownData,
  fetchBaseRepository,
  fetchBaseRepositoryFields,
  resetBaseRepositoryFields,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import PageLoader from '../../../../../components/PageLoader';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import {ArrowBack} from '@material-ui/icons';
import Fields from './FieldsTable';
import useUnsavedChangesWarning from '../../../../../util/CustomHooks';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {backButtonText} from '../../../../../util/Content';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {DATA_REPOSITORY} from '../../../../../constants/ReusableRoleAccess';
import {cannotStartWithNumberRegex} from '../../../../../util/RegexPatterns';
// import MapFieldForm from "../AddFieldList/AddFields";
import {
  submissionEnd,
  submissionStart,
} from '../../../../../redux/reducers/CommonActions/commonActions';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ExtendedRepositoryTable from './ExtendedRepositoryTable';
import FieldSearchTable from './FieldSearchTable';
import throttle from 'lodash/throttle';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const multiRecordOptions = [
  {label: 'Yes', value: 'Y'},
  {label: 'No', value: 'N'},
];
const repositoryTypeOptions = [{value: 'Base'}, {value: 'Extended'}];
const columns = [
  {
    title: 'Actions',
  },
  {
    title: 'Base Field Name',
  },
  {
    title: 'Extended Field Name',
  },
  {
    title: 'Extended Field Label',
  },
  {
    title: 'Extended Field Description',
  },
];

export const removeSpecialCharacters = (inputString) => {
  return inputString?.replace(/[^\w\s]/g, '');
};

const BasicInfoRule = ({
  setTabValue,
  rowSelected,
  isCopyData,
  StepperFieldList,
  setShowSearch,
  handleTabChange,
  globalFieldList,
  setGlobalFieldList,
  repositoryFields,
}) => {
  useEffect(() => {
    dispatch(fetchExistingDataRepositoryNames());
    dispatch(getDropDownData());
    dispatch(fetchBaseRepository());
    setTableNamePrefix('utxn_');
  }, []);

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const companyData = JSON.parse(sessionStorage.getItem('companyName'));
  companyData.unshift('ALL');
  const formDataRef = useRef();
  const drArrayHelpers = useRef();
  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);
  const {roleData} = useSelector(({role}) => role);
  const dataRepoAccess = roleData?.window?.[DATA_REPOSITORY]?.['DR'];
  const dataRepoFieldAccess = roleData?.window?.[DATA_REPOSITORY]?.['RF'];
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [extendedFields, setExtendedFields] = useState([]);

  const initialVal = {
    category: {},
    repoName: '',
    repoDescription: '',
    tableName: '',
    multiRecord: {value: 'N', label: 'No'},
    repoType: {},
    repositoryType: {value: 'Base'},
    company: [],
    criteriaField: '',
    baseRepository: '',
    fields: [],
    criteriaValue: '',
    criteria: {value: 'N', label: 'No'},
  };

  //   data_repo_{debtor},
  //    data_repo_{client}
  // data_repo_{pymt_}
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  // const [isCopyRowData, setIsCopyRowData] = useState(false);
  const isCopyRowData = false;
  const [editExisting, setEditExisting] = useState(false);
  const {udwData} = useSelector(({udwWindows}) => udwWindows);
  const [formData, setFormData] = useState([]);
  const [editable, setEditable] = useState([]);
  const [deletedFields, setDeletedFields] = useState();
  const [deleted, setDeleted] = useState();
  const [reset, setDataReset] = useState();
  const [deletedFieldIds, setDeletedFieldIds] = useState([]);
  const [tableNamePrefix, setTableNamePrefix] = useState('');
  const [showError, setError] = useState(false);
  const [initialValues, setInitialValues] = useState(initialVal);
  const showAlertRef = useRef(false);
  const {routerPrompt, onDirty, onPristine} = useUnsavedChangesWarning();
  const [isOpen, setIsOpen] = useState(false);
  const printusage = useSelector(({printusage}) => printusage);
  const isExtendableDisabled = formData?.filter((el) => ['Y', true]?.includes(el?.isCriteriaField));

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.repositoryName === option) {
          label = item;
        }
      });
    return label;
  };
  const {
    dataRepositoryData,
    isLoading,
    successMsg,
    errorMsg,
    getStatusCode,
    allRepositoryNames,
    DataRepoPrintStatus,
    baseRepositoryData,
    baseRepositoryFieldsData,
  } = useSelector(({dataRepository}) => dataRepository);

  const codeRef = useRef();
  const dirtyRef = useRef(null);

  const handleDirty = (dirty) => {
    showAlertRef.current = dirty;
    if (dirty) {
      onDirty();
    } else {
      onPristine();
    }
  };

  const getWindowNameData = () => {
    if (allRepositoryNames && allRepositoryNames?.length > 0) {
      return allRepositoryNames?.filter(
        (i) => String(i?.repositoryName?.toUpperCase())?.startsWith(nameData?.toUpperCase()) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (getStatusCode === 200) {
      setTimeout(() => {
        dispatch(resetDataRepo());
        setTabValue(0);
      }, 3000);
    }
  }, [getStatusCode]);
  useEffect(() => {
    if (DataRepoPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetDownloadMessage());
      }, 2000);
    }
  }, [DataRepoPrintStatus]);
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      dispatch(submissionEnd());
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);
  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');

  const getCategoryObject = (value, data, type) => {
    const category =
      data &&
      data?.filter((i) => {
        if (type === 'category') {
          return i?.categoryCode === value;
        } else {
          return i?.value?.toLowerCase() === value?.toLowerCase();
        }
      });
    if (category?.length > 0) {
      return category[0];
    }
  };
  const getMultiRecordType = (value) => {
    const type = multiRecordOptions?.find((ele) => ele?.value === value);
    return type;
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (dataRepositoryData && Object.keys(dataRepositoryData)?.length > 0) {
      const start = dataRepositoryData?.category === 'P' ? 15 : 17;

      setTableNamePrefix(dataRepositoryData?.dbTableName?.substr(0, start));
      const fieldsData =
        dataRepositoryData?.dataRepoFieldExtendedRequest?.length > 0 ?
          dataRepositoryData?.dataRepoFieldExtendedRequest?.map((el) => {
            return {
              ...el,
              baseFieldName: el?.baseRepoFieldName || '',
              extendedFieldLabel: el?.fieldLabel || '',
              extendedFieldDescription: el?.fieldDescription || '',
            };
          }) :
          [];
      setExtendedFields(fieldsData);
      if (dataRepositoryData?.repositoryType === 'Extended') {
        dispatch(fetchBaseRepositoryFields(dataRepositoryData?.dataRepositoryId));
      }

      const newInitialValues = {
        category: getCategoryObject(dataRepositoryData?.category, filteredCategory, 'category'),
        repoName: isCopyData ? '' : dataRepositoryData?.repositoryName,
        repoDescription: isCopyData ? '' : dataRepositoryData?.repositoryDescription,
        tableName: isCopyData ?
          '' :
          dataRepositoryData?.dbTableName ?
            dataRepositoryData?.dbTableName.substr(start) :
            '',
        multiRecord: dataRepositoryData?.multiRecord ?
          getMultiRecordType(dataRepositoryData?.multiRecord) :
          {value: 'N', label: 'No'},
        criteria: dataRepositoryData?.isExtendable ?
          getMultiRecordType(dataRepositoryData?.isExtendable) :
          {value: 'N', label: 'No'},
        repositoryType: dataRepositoryData?.repositoryType ?
          getObject(dataRepositoryData?.repositoryType, repositoryTypeOptions) :
          '',
        company: dataRepositoryData?.company?.length > 0 ? dataRepositoryData?.company : [],
        criteriaField: dataRepositoryData?.criteriaField ? dataRepositoryData?.criteriaField : '',
        baseRepository: dataRepositoryData?.baseRepositoryName ?
          getObject(dataRepositoryData?.baseRepositoryName, baseRepositoryData) :
          [],
        fields: fieldsData,
        criteriaValue: dataRepositoryData?.criteriaValue ? dataRepositoryData?.criteriaValue : '',
      };
      setInitialValues(newInitialValues);
    }
    if (
      dataRepositoryData?.dataRepoFieldsRequest &&
      dataRepositoryData?.dataRepoFieldsRequest?.length > 0
    ) {
      const formsData = dataRepositoryData?.dataRepoFieldsRequest?.map((i) => {
        return {
          isAuditNote: i?.auditNote,
          fieldId: i?.fieldDefnId ? i?.fieldDefnId : 0,
          dbTableName: i?.dbTableName ? i?.dbTableName : '',
          fieldDescription: i?.fieldDescription ? i?.fieldDescription : '',
          fieldLabel: i?.fieldLabel ? i?.fieldLabel : '',
          fieldName: i?.fieldName ? i?.fieldName : '',
          fieldType: i?.fieldType ? i?.fieldType : '',
          isEncrypted: i?.isEncrypted,
          isIndexed: i?.isIndexed,
          isMandatory: i?.isMandatory,
          isUnique: i?.isUnique,
          listType: i?.listType ? i?.listType : '',
          listValue: i?.listValue ? i?.listValue : '',
          maxLength: i?.maxLength ? i?.maxLength : '',
          maxValue: i?.maxValue && i?.maxValue !== 'N' ? i?.maxValue : '',
          minLength: i?.minLength ? i?.minLength : '',
          minValue: i?.minValue && i?.minValue !== 'N' ? i?.minValue : '',
          multiSelect: i?.multiSelect,
          repositoryName: i?.repoName,
          seqNo: i?.sequenceNo ? i?.sequenceNo : 0,
          dbColumnName: i?.tableColumnName ? i?.tableColumnName : '',
          viewOnly: i?.viewOnly,
          validations: i?.validations,
          validationType: i?.validationType,
          globalFieldName: i?.globalFieldName,
          IMPORT: i?.useInImport,
          EXPORT: i?.useInExport,
          WORK_QUEUE: i?.useInWorkQueue,
          TRIGGER: i?.useInTrigger,
          REPORT: i?.useInReport,
          isCriteriaField: i?.isCriteriaField,
        };
      });
      setFormData(formsData);
    }
  }, [dataRepositoryData, baseRepositoryData, reset]);

  useEffect(() => {
    if (formData?.length > 0 && formDataRef?.current?.values?.repositoryType?.value === 'Base') {
      setError(false);
    }
  }, [formData]);
  useEffect(() => {
    if (
      formDataRef?.current?.values?.fields?.length > 0 &&
      formDataRef?.current?.values?.repositoryType?.value === 'Extended'
    ) {
      setError(false);
    }
  }, [formDataRef?.current?.values?.fields]);
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const fieldsData = [];
    if (formData?.length === 0 && values?.repositoryType?.value === 'Base') {
      setError(true);
      return;
    } else if (values?.fields?.length === 0 && values?.repositoryType?.value === 'Extended') {
      setError(true);
      return;
    } else if (values) {
      formData &&
        formData?.length > 0 &&
        formData?.map((i, index) => {
          const obj = {
            auditNote: i?.isAuditNote,
            dbTableName:
              values?.repositoryType?.value === 'Base' && values?.tableName ?
                tableNamePrefix + values?.tableName :
                '',
            fieldDescription: i?.fieldLabel,
            fieldDefnId: isCopyData ? 0 : i?.fieldId ? i?.fieldId : 0,
            fieldLabel: i?.fieldLabel ? i?.fieldLabel : '',
            fieldName: i?.fieldName ? i?.fieldName : '',
            fieldType: i?.fieldType ? i?.fieldType : '',
            isEncrypted: i?.isEncrypted,
            isIndexed: i?.isIndexed,
            isMandatory: i?.isMandatory,
            isUnique: i?.isUnique,
            // fieldDefnId: 0,
            listType: i?.listType ? i?.listType : '',
            listValue: i?.listValue ? i?.listValue?.toString() : 'N',
            maxLength: i?.maxLength ? i?.maxLength : null,
            maxValue: i?.maxValue ? i?.maxValue : 'N',
            minLength: i?.minLength ? i?.minLength : null,
            minValue: i?.minValue ? i?.minValue : 'N',
            multiSelect: i?.multiSelect,
            repositoryName: values?.repoName ? // ? values?.repoName?.toUpperCase().replaceAll(" ", "_")
              values?.repoName :
              '',
            seqNo: index + 1,
            tableColumnName: i?.dbColumnName ? i?.dbColumnName : '',
            viewOnly: i?.viewOnly,
            // globalFieldName: i?.globalFieldName ? i?.globalFieldName : "",
            validations: i?.validations?.length > 0 ? i?.validations : [],
            validationType: i?.validationType ? i?.validationType : '',
            useInExport: i?.EXPORT === 'Y' ? 'Y' : 'N',
            useInImport: i?.IMPORT === 'Y' ? 'Y' : 'N',
            useInReport: i?.REPORT === 'Y' ? 'Y' : 'N',
            useInTrigger: i?.TRIGGER === 'Y' ? 'Y' : 'N',
            useInWorkQueue: i?.WORK_QUEUE === 'Y' ? 'Y' : 'N',
            isCriteriaField: i?.isCriteriaField === 'Y' ? 'Y' : 'N',
          };
          fieldsData?.push(obj);
        });
      const getExtendedFieldId = (data, row) => {
        let fieldId = 0;
        data?.forEach((e) => {
          if (e?.baseFieldName === row.baseFieldName && e.fieldId) {
            fieldId = e.fieldId;
          }
        });
        return fieldId;
      };
      const extendedFieldsData =
        values?.fields?.length > 0 ?
          values?.fields?.map((el) => {
            return {
              fieldDefnId: el?.fieldDefnId ? el?.fieldDefnId : 0,
              fieldId: getExtendedFieldId(extendedFields, el),
              fieldLabel: el?.extendedFieldLabel ? el?.extendedFieldLabel : '',
              fieldName: el?.fieldName ? el?.fieldName : '',
              repositoryName: values?.repoName ? // ? values?.repoName?.toUpperCase().replaceAll(" ", "_")
                values?.repoName :
                '',
              fieldDescription: el?.extendedFieldDescription ? el?.extendedFieldDescription : '',
              baseRepoFieldName: el?.baseFieldName ? el?.baseFieldName : '',
            };
          }) :
          [];
      const sameFields = values?.fields?.map((el) => el.baseFieldName);
      const deletedExtendedId = extendedFields
        ?.filter((el) =>
          !sameFields?.includes(el.baseFieldName) && el.fieldId ? el.fieldId : null,
        )
        .map((el) => el.fieldId);
      const ValueObj = {
        category:
          values?.repositoryType?.value === 'Base' && values?.category?.categoryCode ?
            values?.category?.categoryCode :
            '',
        baseRepositoryName:
          values?.repositoryType?.value === 'Extended' && values?.baseRepository?.repositoryName ?
            values?.baseRepository?.repositoryName :
            '',
        dataRepoFieldsRequest:
          values?.repositoryType?.value === 'Base' && fieldsData?.length > 0 ? fieldsData : [],

        company:
          values?.repositoryType?.value === 'Base' && values?.company?.length > 0 ?
            values?.company?.map((el) => el) :
            [],
        criteriaField: values?.criteriaField ? values?.criteriaField : '',
        criteriaValue:
          values?.repositoryType?.value === 'Extended' && values?.criteriaValue ?
            values?.criteriaValue :
            '',
        dataRepoFieldExtendedRequest:
          values?.repositoryType?.value === 'Extended' ? extendedFieldsData : [],
        deletedExtendedFieldId:
          values?.repositoryType?.value === 'Extended' ? deletedExtendedId : [0],
        dataRepositoryId: isCopyData ?
          0 :
          dataRepositoryData?.dataRepositoryId ?
            dataRepositoryData?.dataRepositoryId :
            0,
        dbTableName:
          values?.repositoryType?.value === 'Base' ?
            dataRepositoryData?.dataRepositoryId ?
              dataRepositoryData?.dbTableName :
              values?.tableName ?
              `${tableNamePrefix}${values?.tableName}` :
                '' :
            '',
        deletedFieldsId:
          values?.repositoryType?.value === 'Base' && deletedFieldIds && deletedFieldIds?.length > 0 ?
            deletedFieldIds :
            [],
        // key1: "N",
        // key2: "",
        // key3: "",
        // key4: "",
        // key5: "",
        // key6: "",
        // key7: "",
        // key8: "",
        multiRecord:
          values?.repositoryType?.value === 'Base' && values?.multiRecord?.value ?
            values?.multiRecord?.value :
            '',
        repositoryDescription: values?.repoDescription ? values?.repoDescription : '',
        repositoryName: values?.repoName ? // ? values?.repoName?.toUpperCase().replaceAll(" ", "_")
          values?.repoName :
          '',
        repositoryType: values?.repositoryType?.value ? values?.repositoryType?.value : '',
        isExtendable:
          values?.repositoryType?.value === 'Base' && values?.criteria?.value ?
            values?.criteria?.value :
            '',
      };
      dispatch(postDataRepository(ValueObj));
    }
  };

  const checkNameExist = (value) => {
    if (allRepositoryNames && allRepositoryNames?.length > 0 && value) {
      const ar = [];
      allRepositoryNames.filter((i) => {
        if (
          i?.repositoryName?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkNameAlreadyExist = (value) => {
    if (allRepositoryNames && allRepositoryNames?.length > 0 && value) {
      const ar = [];
      allRepositoryNames.filter((i) => {
        if (
          i?.repositoryName?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const validationSchema = Yup.object().shape({
    repoName:
      !dataRepositoryData?.repositoryName && !isCopyData ?
        Yup.string()
          .test('repoName', 'Repository Name already exist', (value) => !checkNameExist(value))
          .test(
            'repoName',
            'Repository Name has already been used in the past',
            (value) => !checkNameAlreadyExist(value),
          )
          .required('Repository Name is required')
        : // .matches(/^[a-zA-Z0-9\_]+$/, "Only alphabets, numbers and underscore(_) are allowed")
      // .matches(
      //   cannotStartWithNumberRegex,
      //   "Repository name cannot start with number or special character"
      // )
        null,

    repoDescription: Yup.string()
      .required('Repository Description is required'),
    tableName:
      !dataRepositoryData?.repositoryName &&
      !isCopyData &&
      formDataRef.current?.values?.repositoryType?.value === 'Base' ?
        Yup.string()
          .matches(
            /^[a-zA-Z0-9\_]+$/,
            'Please use only the English letters (A-Z, a-z), numerals (0-9) and _',
          )

          .matches(
            cannotStartWithNumberRegex,
            'Table name cannot start with number or special character',
          )
          .required('Table Name is required') :
        '',
    category: Yup.mixed().test('category', 'Category is required', (value, ctx) => {
      if (!value?.categoryCode && ctx.parent.repositoryType?.value === 'Base') {
        return false;
      } else {
        return true;
      }
    }),
    criteriaValue:
      formDataRef.current?.values?.repositoryType?.value === 'Extended' ?
        Yup.string().required('Criteria Value is required') :
        '',
    multiRecord: Yup.mixed().test('multiRecord', 'Multi Record is required', (value, ctx) => {
      if (!value?.value && ctx.parent.repositoryType?.value === 'Base') {
        return false;
      } else {
        return true;
      }
    }),
    criteria: Yup.mixed().test('criteria', 'Is Extendable is required', (value, ctx) => {
      if (!value?.value && ctx.parent.repositoryType?.value === 'Base') {
        return false;
      } else {
        return true;
      }
    }),
    repositoryType: Yup.mixed().test('repositoryType', 'Repository Type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    fields: Yup.array().of(
      Yup.object().shape({
        fieldName:
          formDataRef.current?.values?.repositoryType?.value === 'Extended' ?
            Yup.mixed()
              .test('fieldName', 'Extended Field Name is required', (value) => {
                if (!value) {
                  return false;
                } else {
                  return true;
                }
              })
              .test(
                'duplicate check',
                (path) => {
                  return `Extended Field name ${path.value} is already defined`;
                },
                (value, context) => {
                  const form = context.from[1] || [];
                  const tempFieldNames = form?.value?.fields.filter((el) => {
                    return context.originalValue === value && el.fieldName === value;
                  });
                  if (value && tempFieldNames.length > 1) {
                    return false;
                  } else {
                    return true;
                  }
                },
              ) :
            null,
        extendedFieldLabel:
          formDataRef.current?.values?.repositoryType?.value === 'Extended' ?
            Yup.mixed()
              .test('extendedFieldLabel', 'Extended Field Label is required', (value, ctx) => {
                if (!value && formDataRef.current?.values?.repositoryType?.value === 'Extended') {
                  return false;
                } else {
                  return true;
                }
              })
              .test(
                'duplicate check',
                (path) => {
                  return `Extended Field Label ${path.value} is already defined`;
                },
                (value, context) => {
                  const form = context.from[1] || [];
                  const tempFieldNames = form?.value?.fields.filter((el) => {
                    return context.originalValue === value && el.extendedFieldLabel === value;
                  });
                  if (value && tempFieldNames.length > 1) {
                    return false;
                  } else {
                    return true;
                  }
                },
              ) :
            null,
        extendedFieldDescription:
          formDataRef.current?.values?.repositoryType?.value === 'Extended' ?
            Yup.string().required('Extended Field Description is required') :
            null,
      }),
    ),
    company:
      formDataRef.current?.values?.repositoryType?.value === 'Base' ?
        Yup.mixed().test('company', 'Company is required', (value) => {
          if (value?.length > 0) {
            return true;
          } else {
            return false;
          }
        }) :
        null,
  });
  const roleAccess =
    dataRepositoryData?.repositoryType === 'SYSTEM' ||
    (repositoryFields && dataRepositoryData?.repositoryName && !dataRepoFieldAccess?.edit) ||
    (!repositoryFields && !dataRepositoryData?.repositoryName && !dataRepoAccess?.add) ||
    (!repositoryFields && dataRepositoryData?.repositoryName && !dataRepoAccess?.edit) ||
    (repositoryFields && !dataRepositoryData?.repositoryName && !dataRepoFieldAccess?.add);
  const deleteAccess =
    dataRepositoryData?.repositoryType === 'SYSTEM' ||
    (!repositoryFields && dataRepositoryData?.repositoryName && !dataRepoAccess?.edit) ||
    (repositoryFields && dataRepositoryData?.repositoryName && !dataRepoFieldAccess?.edit);
  useEffect(() => {
    if (baseRepositoryFieldsData?.length > 0 && !dataRepositoryData?.dataRepositoryId) {
      const fieldsData = baseRepositoryFieldsData?.map((el) => {
        return {
          ...el,
          baseFieldName: el.fieldName || '',
          extendedFieldLabel: el.fieldLabel || '',
          extendedFieldDescription: el.fieldDescription || '',
        };
      });
      formDataRef.current?.setFieldValue('fields', fieldsData);
    } else if (!dataRepositoryData?.dataRepositoryId) {
      formDataRef.current?.setFieldValue('fields', []);
    }
  }, [baseRepositoryFieldsData]);
  return (
    <>
      <Formik
        onSubmit={(values) => throttle(handleSubmit(values), 3000)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={formDataRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            resetForm,
            dirty,
          } = props;
          handleDirty(dirty || dirtyRef.current);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              {routerPrompt}
              <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
                <Button
                  variant="outlined"
                  type="button"
                  disabled={isLoading}
                  className={`search-btn mx-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    if (showAlertRef.current) {
                      dispatch(
                        setAlertData({
                          showAlert: showAlertRef.current,
                          alertCallback: () => {
                            setTabValue(0);
                          },
                        }),
                      );
                    } else {
                      setTabValue(0);
                    }
                  }}
                >
                  <ArrowBack className="mr-2" />
                  {backButtonText}
                </Button>
                {/* {dataRepositoryData && (
                  <div>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      // disabled={dataRepoUsage.userMetrix === "No"}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            category: dataRepositoryData?.category
                              ? dataRepositoryData?.category
                              : "",
                            fieldListOrderBy: "",
                            fieldListOrderDerection: "",
                            fieldName: dataRepositoryData?.fieldName
                              ? dataRepositoryData.fieldName
                              : "",
                            frameworkUsageOrderBy: "",
                            frameworkUsageOrderDerection: "",
                            repositoryName: dataRepositoryData?.repositoryName
                              ? dataRepositoryData.repositoryName
                              : "",
                            repositoryDescription: dataRepositoryData?.repositoryDescription
                              ? dataRepositoryData?.repositoryDescription
                              : "",
                            repositoryType: dataRepositoryData?.repositoryType
                              ? dataRepositoryData?.repositoryType
                              : "",
                            sourceType: "DATA REPOSITORY",
                          })
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      // disabled={Boolean(dataCount === 0)}
                      onClick={(event) => {
                        dispatch(
                          printDataRepositories({
                            category: dataRepositoryData?.category
                              ? dataRepositoryData?.category
                              : "",
                            fieldName: dataRepositoryData?.fieldName
                              ? dataRepositoryData.fieldName
                              : "",
                            repositoryName: dataRepositoryData?.repositoryName
                              ? dataRepositoryData.repositoryName
                              : "",
                            repositoryDescription: dataRepositoryData?.repositoryDescription
                              ? dataRepositoryData?.repositoryDescription
                              : "",
                            repositoryType: dataRepositoryData?.repositoryType
                              ? dataRepositoryData?.repositoryType
                              : "",
                            orderBy: "",
                            orderDirection: "",
                          })
                        );
                      }}
                    >
                      Download Configuration
                    </Button>
                  </div>
                )} */}
              </div>
              <div className="form-row global-field-textfields new-standard-textfields">
                {/* <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <Autocomplete
                    classes={{
                      option: classes.option,
                      popper: classes.popper,
                    }}
                    name="repoType"
                    // disabled={category}
                    id="repoType"
                    size="small"
                    value={values.repoType}
                    options={[{key : "U", value: "User"}, {key : "S", value: "System"}]}
                    getOptionLabel={(option) => {
                      return option?.key && option?.value ? `${option?.key} - ${option?.value}` : option?.value ? option?.value : "";
                    }}
                    onChange={(e, value) => {
                      setFieldValue("repoType", value);
                    }}
                    placeholder="Select Repository Type"
                    renderInput={(params) => (
                      <div className="select-field">
                        <TextField
                          className={`${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          error={touched.repoType && errors.repoType}
                          variant="outlined"
                          margin="dense"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Repository Type"
                          placeholder="Select Repository Type"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{ color: "red" }} variant="outlined">
                    {touched.repoType && errors.repoType}
                  </FormHelperText>
                </div> */}
                {/* <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                      popper: classes.popper,
                    }}
                    name="category"
                    // disabled={category}
                    id="category"
                    size="small"
                    disabled={!isCopyData && dataRepositoryData?.category}
                    value={values.category}
                    options={filteredCategory}
                    autoHighlight
                    getOptionLabel={(option) => {
                      return option && option.categoryName
                        ? option.categoryCode === null
                          ? option.categoryName
                          : option.categoryCode + " - " + option.categoryName
                        : "";
                    }}
                    onChange={(e, value) => {
                      if (value) {
                        setFieldValue("category", value);
                        let prefix =
                          value?.categoryName === "Payment"
                            ? "data_repo_pymt_"
                            : value?.categoryName === "Client" ? "cu_": "du_" ;
                        setTableNamePrefix(prefix);
                      } else {
                        setFieldValue("category", "");
                      }
                    }}
                    placeholder="Select Category"
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          error={touched.category && errors.category}
                          variant="outlined"
                          margin="dense"
                          required
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Category"
                          placeholder="Select Category"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{ color: "red" }} variant="outlined">
                    {touched.category && errors.category}
                  </FormHelperText>
                </div> */}
                <div className={`col-sm-6 col-md-4 col-xl-3 ${errors?.repoName?.length > 30 ? 'form-group-lg' : 'form-group'}`}>
                  <TextField
                    margin="dense"
                    className={`${classes.labelName}`}
                    variant="outlined"
                    placeholder={`Enter Repository Name`}
                    label="Repository Name"
                    inputProps={{maxLength:25}}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    disabled={!isCopyData && dataRepositoryData?.repositoryName}
                    name="repoName"
                    // value={values?.repoName.replaceAll(" ", "_")}
                    value={values?.repoName}
                    required
                    onChange={(e) => {
                      // let value = upperCaseCode(codeRef);
                      const tableName = removeSpecialCharacters(e.target.value);
                      setFieldValue('tableName', tableName?.toLowerCase()?.replaceAll(' ', '_'));
                      setFieldValue('repoName', e.target.value);
                      if (e.target.value) {
                        setNamePopover(true);
                        setNameData(e?.target?.value);
                      } else if (e.target.value === '') {
                        setNamePopover(false);
                      }
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    inputRef={codeRef}
                    touched={touched.repoName}
                    error={Boolean(touched.repoName && errors.repoName)}
                  />
                  <FormHelperText>
                    {touched.repoName && errors?.repoName && errors?.repoName}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {namePopover &&
                      getWindowNameData()?.map((data, i) => (
                        <MenuItem key={i}>{data?.repositoryName?.replace(/ /g, '\u00a0')}</MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    margin="dense"
                    className={`${classes.labelName}`}
                    variant="outlined"
                    placeholder="Enter Repository Description"
                    label="Repository Description"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    disabled={dataRepositoryData?.repositoryType?.toUpperCase() === 'SYSTEM'}
                    name="repoDescription"
                    value={values.repoDescription}
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    inputProps={{maxLength:100}}
                    touched={touched.repoDescription}
                    error={Boolean(touched.repoDescription && errors.repoDescription)}
                  />
                  <FormHelperText>
                    {touched.repoDescription && errors.repoDescription && errors.repoDescription}
                  </FormHelperText>
                </div>
                <div className="form-group col-sm-4 col-md-4 col-xl-3">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="repositoryType"
                    size="small"
                    options={repositoryTypeOptions}
                    fullWidth
                    value={values?.repositoryType}
                    disabled={!isCopyData && dataRepositoryData?.repositoryType}
                    onBlur={handleBlur}
                    autoHighlight
                    getOptionLabel={(option) => option?.value || ''}
                    renderInput={(params) => (
                      <GuiTextField
                        className={`${classes.labelName}`}
                        {...params}
                        name="repositoryType"
                        error={Boolean(touched?.repositoryType && errors?.repositoryType)}
                        label="Repository Type"
                        variant="outlined"
                        margin="dense"
                        required
                        placeholder="Select Repository Type"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    error={touched?.repositoryType && errors?.repositoryType}
                    touched={touched?.repositoryType}
                    onChange={(event, value) => {
                      setFieldValue('repositoryType', value);
                      setFieldValue('baseRepository', '');
                      setFieldValue('criteriaField', '');
                      dispatch(resetBaseRepositoryFields());
                    }}
                  />
                  <FormHelperText>
                    {touched.repositoryType && errors.repositoryType && errors.repositoryType}
                  </FormHelperText>
                </div>
                {values?.repositoryType?.value === 'Base' && (
                  <>
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                          popper: classes.popper,
                        }}
                        name="category"
                        // disabled={category}
                        id="category"
                        size="small"
                        disabled={!isCopyData && dataRepositoryData?.category}
                        value={values.category}
                        options={filteredCategory}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.categoryName ?
                            option.categoryCode === null ?
                              option.categoryName :
                              option.categoryCode + ' - ' + option.categoryName :
                            '';
                        }}
                        onChange={(e, value) => {
                          if (value) {
                            setFieldValue('category', value);
                            // let prefix =
                            //   value?.categoryName === "Payment"
                            //     ? "data_repo_pymt_"
                            //     : value?.categoryName === "Client"
                            //     ? "txn_"
                            //     : "txn_";
                            // setTableNamePrefix(prefix);
                          } else {
                            setFieldValue('category', '');
                          }
                        }}
                        placeholder="Select Category"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              error={touched.category && errors.category}
                              variant="outlined"
                              margin="dense"
                              required
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              label="Category"
                              placeholder="Select Category"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}} variant="outlined">
                        {touched.category && errors.category}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-6 col-md-4 col-xl-3  form-group custom-field-name dataManagement-tableName">
                      <TextField
                        margin="dense"
                        className={`${classes.labelName}`}
                        variant="outlined"
                        placeholder={tableNamePrefix === '' ? 'Enter Table Name' : ''}
                        label="Table Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        disabled={!isCopyData && dataRepositoryData?.dbTableName}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className="custom-input-adornment">
                              {<div className="table-disablefield">{tableNamePrefix}</div>}
                            </InputAdornment>
                          ),
                        }}
                        name="tableName"
                        value={values.tableName}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.tableName}
                        error={Boolean(touched.tableName && errors.tableName)}
                      />
                      <FormHelperText>
                        {touched.tableName && errors.tableName && errors.tableName}
                      </FormHelperText>
                    </div>
                  </>
                )}
                {['Extended']?.includes(values?.repositoryType?.value) && (
                  <div className="form-group col-sm-4 col-md-4 col-xl-3">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="baseRepository"
                      size="small"
                      options={baseRepositoryData}
                      fullWidth
                      label="Multi Record"
                      value={values?.baseRepository}
                      disabled={!isCopyData && dataRepositoryData?.baseRepositoryName}
                      onBlur={handleBlur}
                      autoHighlight
                      getOptionLabel={(option) =>
                        option?.repositoryName ? option?.repositoryName : ''
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          name="multiRecord"
                          error={Boolean(touched?.baseRepository && errors?.baseRepository)}
                          label="Base Repository"
                          variant="outlined"
                          margin="dense"
                          required
                          placeholder="Select Base Repository"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      error={touched?.baseRepository && errors?.baseRepository}
                      touched={touched?.baseRepository}
                      onChange={(event, value) => {
                        setFieldValue('baseRepository', value);
                        if (value?.repositoryName) {
                          setFieldValue('criteriaField', value?.criteriaField);
                          dispatch(fetchBaseRepositoryFields(value?.dataRepositoryId));
                        } else {
                          setFieldValue('criteriaField', '');
                          dispatch(resetBaseRepositoryFields());
                        }
                      }}
                    />
                    <FormHelperText>
                      {touched.baseRepository && errors.baseRepository && errors.baseRepository}
                    </FormHelperText>
                  </div>
                )}
                {['Extended']?.includes(values?.repositoryType?.value) && (
                  <div className="form-group col-sm-4 col-md-4 col-xl-3">
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder="Enter Criteria Field"
                      label="Criteria Field"
                      name="criteriaField"
                      disabled={
                        ['Extended']?.includes(values?.repositoryType?.value) ||
                        ['Extended']?.includes(dataRepositoryData?.repositoryType)
                      }
                      value={values.criteriaField}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.criteriaField}
                      error={Boolean(touched.criteriaField && errors.criteriaField)}
                    />
                    <FormHelperText>
                      {touched.criteriaField && errors.criteriaField && errors.criteriaField}
                    </FormHelperText>
                  </div>
                )}
                {['Extended']?.includes(values?.repositoryType?.value) && (
                  <div className="form-group col-sm-4 col-md-4 col-xl-3">
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder="Enter Criteria Value"
                      label="Criteria Value"
                      name="criteriaValue"
                      required
                      value={values.criteriaValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.criteriaValue}
                      error={Boolean(touched.criteriaValue && errors.criteriaValue)}
                    />
                    <FormHelperText>
                      {touched.criteriaValue && errors.criteriaValue && errors.criteriaValue}
                    </FormHelperText>
                  </div>
                )}
                {values?.repositoryType?.value === 'Base' && (
                  <>
                    <div className="form-group col-sm-4 col-md-4 col-xl-3">
                      <GuiAutoComplete
                        name={'company'}
                        id={'company'}
                        size="small"
                        limitTags={1}
                        classes={{
                          option: classes.option,
                          listbox: classes.listBox,
                        }}
                        disableCloseOnSelect
                        getOptionSelected={(option, value) => option === value}
                        value={values?.company?.length > 0 ? values?.company : []}
                        multiple
                        onChange={(e, value) => {
                          setFieldValue('company', value);
                        }}
                        options={companyData}
                        autoHighlight
                        renderOption={(option, {selected}) => {
                          return (
                            <React.Fragment>
                              <>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={
                                    <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                  }
                                  checked={selected}
                                />
                              </>
                              {option ? option : ''}
                            </React.Fragment>
                          );
                        }}
                        getOptionLabel={(option) => {
                          return option ? option : '';
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              className={` autocomplete-multiselect-label ${classes.labelName}`}
                              margin="dense"
                              touched={touched}
                              error={touched?.company && errors?.company}
                              label={'Company'}
                              placeholder={`Select Company`}
                              required
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off', // disable autocomplete and autofill
                              }}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.company && errors.company && errors.company}
                      </FormHelperText>
                    </div>
                    <div className="form-group col-sm-4 col-md-4 col-xl-3">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="criteria"
                        size="small"
                        options={multiRecordOptions}
                        fullWidth
                        label="Is Extendable"
                        value={values?.criteria}
                        disabled={
                          (!isCopyData && isExtendableDisabled?.length > 0) ||
                          (!isCopyData && dataRepositoryData?.isAlreadyExtended === 'Y')
                        }
                        onBlur={handleBlur}
                        autoHighlight
                        getOptionLabel={(option) => option?.label || ''}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            name="criteria"
                            error={Boolean(touched?.criteria && errors?.criteria)}
                            label="Is Extendable"
                            variant="outlined"
                            margin="dense"
                            required
                            placeholder="Is Extendable"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                        error={touched?.criteria && errors?.criteria}
                        touched={touched?.criteria}
                        onChange={(event, value) => {
                          setFieldValue('criteria', value);
                        }}
                      />
                      <FormHelperText>
                        {touched.criteria && errors.criteria && errors.criteria}
                      </FormHelperText>
                    </div>
                    <div className="form-group col-sm-4 col-md-4 col-xl-3">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="multiRecord"
                        size="small"
                        options={multiRecordOptions}
                        fullWidth
                        label="Multi Record"
                        value={values?.multiRecord}
                        disabled={!isCopyData && dataRepositoryData?.multiRecord}
                        onBlur={handleBlur}
                        autoHighlight
                        getOptionLabel={(option) => option?.label || ''}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            name="multiRecord"
                            error={Boolean(touched?.multiRecord && errors?.multiRecord)}
                            label="Multi Record"
                            variant="outlined"
                            margin="dense"
                            required
                            placeholder="Select Multi Record"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                        error={touched?.multiRecord && errors?.multiRecord}
                        touched={touched?.multiRecord}
                        onChange={(event, value) => {
                          setFieldValue('multiRecord', value);
                        }}
                      />
                      <FormHelperText>
                        {touched.multiRecord && errors.multiRecord && errors.multiRecord}
                      </FormHelperText>
                    </div>
                  </>
                )}
              </div>
              {['Base']?.includes(values?.repositoryType?.value) ? (
                <Fields
                  udwView={false}
                  UDWData={udwData}
                  formData={formData}
                  adduser-password-fields
                  setFormData={setFormData}
                  isCopyRowData={isCopyRowData}
                  editable={editable}
                  reset={reset}
                  setEditable={setEditable}
                  setDeletedFields={setDeletedFields}
                  deletedFields={deletedFields}
                  editExisting={editExisting}
                  setDeleted={setDeleted}
                  initialValues={initialValues}
                  setEditExisting={setEditExisting}
                  deleted={deleted}
                  dirty={false}
                  setDeletedFieldIds={setDeletedFieldIds}
                  deletedFieldIds={deletedFieldIds}
                  dataRepositoryData={dataRepositoryData}
                  roleAccess={roleAccess}
                  deleteAccess={deleteAccess}
                  dirtyRef={dirtyRef}
                  isCriteria={values?.criteria?.value}
                  isAlreadyExtended={dataRepositoryData?.isAlreadyExtended}
                />
              ) : ['Extended']?.includes(values?.repositoryType?.value) ? (
                <FieldArray
                  name="fields"
                  render={(arrayHelpers) => {
                    drArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div className={'table-header justify-content-end new-standard-textfields'}>
                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              setIsOpen(true);
                            }}
                            startIcon={<AccountTreeIcon />}
                          >
                            {'Map Fields'}
                          </Button>
                        </div>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields '
                          }
                        >
                          <table>
                            <thead className="recFormat-header-container">
                              <tr>
                                {columns.map(
                                  ({title, hidden = false}) =>
                                    !hidden && (
                                      <th key={title} className="recFormat-header">
                                        {title}
                                      </th>
                                    ),
                                )}
                              </tr>
                            </thead>
                            {values.fields?.length > 0 ? (
                              <tbody className="recFormat-body">
                                {values.fields.map((field, index) => (
                                  <>
                                    <Field
                                      key={index}
                                      name={'fields' + '[' + index + ']'}
                                      component={ExtendedRepositoryTable}
                                      index={index}
                                      columns={columns}
                                      values={values}
                                      setFieldValue={setFieldValue}
                                      drArrayHelpers={drArrayHelpers}
                                      extendedFieldsData={extendedFields}
                                    />
                                  </>
                                ))}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan={columns.length}>
                                    No records to display
                                    {/* To add fields to your report click the
                                    "Add Fields" button in the top right of this section. */}
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                      </>
                    );
                  }}
                />
              ) : null}
              {showError && (
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <FormHelperText>
                    At least 1 field is required before you can save your Data Repository.
                  </FormHelperText>
                </div>
              )}
              <div
                className={
                  dataRepositoryData ?
                    'd-flex justify-content-center align-items-center mb-2 mt-3 new-standard-textfields' :
                    'd-flex justify-content-center align-items-center mt-3 new-standard-textfields'
                }
              >
                <Button
                  variant="outlined"
                  type="reset"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  disabled={roleAccess}
                  onClick={() => {
                    if (dataRepositoryData && Object.keys(dataRepositoryData)?.length > 0) {
                      resetForm(initialValues);
                      setDataReset(!reset);
                      setDeletedFieldIds([]);
                    } else {
                      resetForm(initialValues);
                      setFormData([]);
                      setTableNamePrefix('utxn_');
                      setError(false);
                    }
                  }}
                >
                  Reset
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={roleAccess}
                >
                  Save
                </Button>
              </div>
              <DialogBox open={isOpen} dialogClose={handleClose} title={'Map Fields'} maxWidth="xl">
                <FieldSearchTable
                  handleClose={handleClose}
                  values={values}
                  setFieldValue={setFieldValue}
                  setTempSelectedRows={setTempSelectedRows}
                  tempSelectedRows={tempSelectedRows}
                  baseRepositoryFieldsData={baseRepositoryFieldsData}
                />
              </DialogBox>
            </form>
          );
        }}
      </Formik>
      {/* {!isCopyData && dataRepositoryData?.dataRepositoryId && (
     <div className={`${classes1.root} mt-3`}>
          <Accordion
            className="accordion-styling"
            expanded={expanded === "panel1"}
            onChange={handleAccordionChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMore sx={{ fontSize: "0.9rem" }} />}
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography className={classes1.heading}>Data Repository System Notes</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <DataRepositorySystemNotes filedListCode={dataRepositoryData?.repositoryName} />
            </AccordionDetails>
          </Accordion>
        </div>)} */}
      {isLoading && <PageLoader />}
      {printusage?.isLoading && <PageLoader />}
      {(errorMsg || printusage?.errorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg} />
      )}
      {(successMsg || printusage?.successMsg) && (
        <SuccessSnackbar successMsg={successMsg || printusage?.successMsg} />
      )}
    </>
  );
};

export default BasicInfoRule;
